// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h4mA","toggle":"styles_toggle__2nzQH","preview":"styles_preview__2y3BH"};